import BaseIcon from "@/components/UI/BaseIcon";

export default {
  name: "preconditional-order-info-modal",
  components: {
    BaseIcon,
  },
  props: {
    showModal: {
      type: Boolean,
    },
  },
  data() {
    return {
      stopOrderType: "buy",
    };
  },
  computed: {},
  mounted() {},
  methods: {},
};
